<template>
    <div class="mb-4">
        <div class="px-0 mt-3">
            <b-row class="mb-3">
                <b-col cols="12" md="3">
                    <label>{{ $t('Chinese Name') }} <span class="text-danger">*</span></label>
                </b-col>

                <b-col sm="12" md="9">
                    <input type="text" class="form-control" v-model="params.name" @keydown="onChange('name')"/>
                    <div v-if="error['name']" class="invalid-feedback d-block mb-3">
                        {{$t(error['name'])}}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-3">
                <b-col cols="12" md="3">
                    <label>{{ $t('English Name') }} <span class="text-danger">*</span></label>
                </b-col>

                <b-col sm="12" md="9">
                    <input type="text" class="form-control" v-model="params.enName" @keydown="onChange('enName')"/>
                    <div v-if="error['enName']" class="invalid-feedback d-block mb-3">
                        {{$t(error['enName'])}}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-3">
                <b-col cols="12" md="3">
                    <label>{{ $t('ID Number') }} <span class="text-danger">*</span></label>
                </b-col>

                <b-col sm="12" md="9">
                    <input type="text" class="form-control" v-model="params.idNo" @keydown="onChange('idNo')"/>
                    <div v-if="error['idNo']" class="invalid-feedback d-block mb-3">
                        {{$t(error['idNo'])}}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-3">
                <b-col cols="12" md="3">
                    <label>{{ $t('Date of Birth') }} <span class="text-danger">*</span></label>
                </b-col>

                <b-col sm="12" md="9">
                    <date-picker v-model="params.birthDate" :lang="lang_date" input-class="form-control" format="YYYY-MM-DD" value-type="YYYY-MM-DD" @change="onChange('birthDate')"></date-picker>
                    <div v-if="error['birthDate']" class="invalid-feedback d-block mb-3">
                        {{$t(error['birthDate'])}}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-3">
                <b-col cols="12" md="3">
                    <label>{{ $t('ID Photo') }} <span class="text-danger">*</span></label>
                </b-col>

                <b-col sm="12" md="3">
                    <div class="d-flex justify-content-center">
                        <label class="pt-2">{{ $t('ID Photo Front Side') }} <span class="text-danger">*</span></label>
                        <span class="position-relative">
                            <button type="button" class="flat-button position-absolute" @click="togglePopup(1)">
                            <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                            </button>
                            <NewPopupInfo :name="'ic_front'" v-if="showPopup_1" :addClass="'popup-info-center'"></NewPopupInfo>
                        </span>
                    </div>
                    <FileUploader  
                        :type="'browse'"
                        :allowed_types = "['jpg','jpeg', 'png']"
                        :size="4*1024*1024"
                        :ref="'idFront'"
                        @capture-file="captureFile($event,'idFront')" 
                        @remove-image="removeImage($event,'idFront')"
                        @toggle-camera="toggleCamera($event)">
                    </FileUploader>
                    <div v-if="error['idFront']" class="invalid-feedback d-block mb-3">
                        {{$t(error['idFront'])}}
                    </div>
                </b-col>
                <b-col sm="12" md="3">
                    <div class="d-flex justify-content-center">
                        <label class="pt-2">{{ $t('ID Photo Back Side') }} <span class="text-danger">*</span></label>
                        <span class="position-relative">
                            <button type="button" class="flat-button position-absolute" @click="togglePopup(2)">
                            <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                            </button>
                            <NewPopupInfo :name="'ic_national'" v-if="showPopup_2" :addClass="'popup-info-center'"></NewPopupInfo>
                        </span>
                    </div>
                    <FileUploader  
                        :type="'browse'"
                        :allowed_types = "['jpg','jpeg', 'png']"
                        :size="4*1024*1024"
                        :ref="'idReverse'"
                        @capture-file="captureFile($event,'idReverse')" 
                        @remove-image="removeImage($event,'idReverse')"
                        @toggle-camera="toggleCamera($event)">
                    </FileUploader>
                    <div v-if="error['idReverse']" class="invalid-feedback d-block mb-3">
                        {{$t(error['idReverse'])}}
                    </div>
                </b-col>
                <b-col sm="12" md="3">
                    <div class="d-flex justify-content-center">
                        <label class="pt-2">{{ $t('Holding ID Card') }} <span class="text-danger">*</span></label>
                        <span class="position-relative">
                            <button type="button" class="flat-button position-absolute" @click="togglePopup(3)">
                            <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                            </button>
                            <NewPopupInfo :name="'ic_holding'" v-if="showPopup_3" :addClass="'popup-info-center'"></NewPopupInfo>
                        </span>
                    </div>
                    <FileUploader  
                        :type="'browse'"
                        :allowed_types = "['jpg','jpeg', 'png']"
                        :size="4*1024*1024"
                        :ref="'idHold'"
                        @capture-file="captureFile($event,'idHold')" 
                        @remove-image="removeImage($event,'idHold')"
                        @toggle-camera="toggleCamera($event)">
                    </FileUploader>
                    <div v-if="error['idHold']" class="invalid-feedback d-block mb-3">
                        {{$t(error['idHold'])}}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-3">
                <b-col cols="12" md="3">
                    <label>{{ $t('Certificate Validity Period') }} <span class="text-danger">*</span></label>
                </b-col>

                <b-col sm="12" md="9">
                    <date-picker v-model="params.legalCertExpiryDate" :lang="lang_date" input-class="form-control" format="YYYY-MM-DD" value-type="YYYY-MM-DD" @change="onChange('legalCertExpiryDate')"></date-picker>
                    <div v-if="error['legalCertExpiryDate']" class="invalid-feedback d-block mb-3">
                        {{$t(error['legalCertExpiryDate'])}}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-4">
                <b-col xl="4" sm="12">
                    <div class="form-group mb-0">
                        <label>{{ $t('Province') }} <span class="text-danger">*</span></label>
                        <Select2 v-model="params.province" :options="provinceOpt" @select="onSelectProvince($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Province")}' class="form-control"/>
                        <div v-if="error['province']" class="invalid-feedback d-block mb-3">
                            {{$t(error['province'])}}
                        </div>
                    </div>
                </b-col>
                <b-col xl="4" sm="12">
                    <div class="form-group mb-0">
                        <label>{{ $t('City') }} <span class="text-danger">*</span></label>
                        <Select2 v-model="params.city" :options="cityOpt" @select="onSelectCity($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("City")}' class="form-control"/>
                        <div v-if="error['city']" class="invalid-feedback d-block mb-3">
                            {{$t(error['city'])}}
                        </div>
                    </div>
                </b-col>
                <b-col xl="4" sm="12">
                    <div class="form-group mb-0">
                        <label>{{ $t('District') }} <span class="text-danger">*</span></label>
                        <Select2 v-model="params.area" :options="districtOpt" @select="onSelectDistrict($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("District")}' class="form-control"/>
                        <div v-if="error['area']" class="invalid-feedback d-block mb-3">
                            {{$t(error['area'])}}
                        </div>
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-4">
                <b-col cols="12" md="6">
                    <div class="form-group mb-0">
                        <label>{{ $t('Address') }} <span class="text-danger">*</span></label>
                        <input type="text" name="address" v-model="params.address" class="form-control" @keydown="addressCondition($event)" @keyup="onchangeAddress($event)"/>
                        <div v-if="error['address']" class="invalid-feedback d-block mb-3">
                            {{$t(error['address'])}}
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="6">
                    <div class="form-group mb-0">
                        <label>{{ $t('Postal Code') }} <span class="text-danger">*</span></label>
                        <input type="text" name="postCode" v-model="params.postCode" class="form-control" @keyup="onChange('postCode')"/>
                        <div v-if="error['postCode']" class="invalid-feedback d-block mb-3">
                            {{$t(error['postCode'])}}
                        </div>
                    </div>
                </b-col>
            </b-row>

        </div>
        
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Select2 from 'v-select2-component';

import NewDocOption from "@/components/Kyc/NewDocOption";
import FileUploader from '@/components/Kyc/FileUploader.vue';
import NewPopupInfo from '@/components/NewPopupInfo.vue';
import CreateAccount from '@/services/CreateAccount';

import 'vue2-datepicker/locale/zh-cn';
import 'vue2-datepicker/locale/zh-tw';
import 'vue2-datepicker/locale/ja';
import 'vue2-datepicker/locale/en';

export default {
  data() {
    return {
        publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        cityOpt:[],
        districtOpt:[],
        provinceOpt:[],
        lang_date:'en',
        maxSize:4,
        showPopup_1:false,
        showPopup_2:false,
        showPopup_3:false,
        success:null,
        userNo:null,
        accountId:null,
        file:{
            idFront:null,
            idReverse:null,
            idHold:null,
        },
        params:{
            idFront:'',
            idReverse:'',
            idHold:'',
            name:'',
            enName:'',
            province:'',
            city:'',
            area:'',
            address:'',
            postCode:'',
            legalCertExpiryDate:'',
            birthDate:'',
            idNo:''
        },
        error:{
            idFront:'',
            idReverse:'',
            idHold:'',
            name:'',
            enName:'',
            province:'',
            city:'',
            area:'',
            address:'',
            postCode:'',
            legalCertExpiryDate:'',
            birthDate:'',
            idNo:''
        }
    }
  },
  components:{
    NewDocOption,
    FileUploader,
    Select2,
    NewPopupInfo,
    DatePicker
  },
  props:['information','user_no','account_id'],
  methods:{
    getFile(index,file_id){
        let self = this;
        CreateAccount.getFile({fileId:file_id}).then(response => {
            let data_file = response.data.data[0];
            if(data_file.type == 2 || data_file.type == 5){
                self.params.idFront = data_file.file;
                self.$refs['idFront'].image =data_file.file;
            }
            else if(data_file.type == 4 || data_file.type == 6){
                self.params.idHold = data_file.file;
                self.$refs['idHold'].image =data_file.file;
            }
            else if(data_file.type == 3){
                self.params.idReverse = data_file.file;
                self.$refs['idReverse'].image =data_file.file;
            }
        });
    },
    addressCondition($event){
        if($event.keyCode == 13){
            $event.preventDefault();
        }
        this.onChange('address');
    },
    onchangeAddress($event){
        let msg = $event.target.value.replace("\n", " ");
        $event.target.value = msg;
    },
    onSelectDistrict({id,text}){
        var self = this;
        this.onChange('area');
    },
    onSelectCity({id,text,code}){
        var self = this;
        this.onChange('city');
        if(text){
            this.area="";
        }
        this.getDistrict(code);
    },
    onSelectProvince({id,text,code}){
        var self = this;
        this.onChange('province');
        self.districtOpt = [];
        if(text){
            this.city = "";
            this.area = "";
        }
        this.getCity(code);
    },
    getDistrict(code){
        this.districtOpt = [];
        CreateAccount.getDistrict({"city_id":code}).then(response => {
            const data = response.data.data;
            data.forEach(item => {
                this.districtOpt.push({"id":item.value,"text":item.text,"code":item.code});
            });
        }).catch(err => {
            this.checkError(err);
        });
    },
    getCity(code){
        this.cityOpt = [];
        CreateAccount.getCity({"province_id":code}).then(response => {
            const data = response.data.data;
            data.forEach(item => {
                this.cityOpt.push({"id":item.value,"text":item.text,"code":item.code});
            });
        }).catch(err => {
            this.checkError(err);
        });
    },
    onChange(name){
        this.error[name]="";
    },
    validate(){
        let success = true;
        let self = this;
        Object.keys(this.params).forEach(function(key) {
            console.log(key+":"+self.params[key]);
            if(self.params[key]=='' || self.params[key]==null){
                self.error[key]="can not be blank.";
                success = false;
            }
        });

        return success;
    },
    uploadFile(account_id,user_no){
        let self = this;
        this.success = null;

        this.accountId = account_id;
        this.userNo = user_no;
        
        this.error.idFront='';
        this.error.idHold='';
        this.error.idReverse='';

        let fileList = [
            {
                "type":2,
                "maxSize":self.maxSize*1024*1024,
                "file":self.params.idFront
            },
            {
                "type":3,
                "maxSize":self.maxSize*1024*1024,
                "file":self.params.idReverse
            },
            {
                "type":4,
                "maxSize":self.maxSize*1024*1024,
                "file":self.params.idHold
            }
        ];

        CreateAccount.uploadFile({
            "accountId":self.accountId,
            "userNo":""+self.userNo,
            "fileUpload":fileList
        }).then(response => {
            const data = response.data.data;
            let fileList = data["file"];
            for(let i=0;i<fileList.length;i++){
                if(fileList[i].type==2 || fileList[i].type==5){
                    // self.params.idFront = fileList[i].file;
                    self.file.idFront = fileList[i].fileId;
                }
                else if(fileList[i].type==4 || fileList[i].type==6){
                    // self.params.idHold = fileList[i].file;
                    self.file.idHold = fileList[i].fileId;
                }
                else if(fileList[i].type==3){
                    // self.params.idReverse = fileList[i].file;
                    self.file.idReverse = fileList[i].fileId;
                }
            }
            self.success = true;
            self.$emit('file-uploaded');
        }).catch(err => {
            self.checkError(err);
        });
    },
    checkError(err){
        try{
            let self = this;
            const response = err.response;  
            if(response.status == 400){
                if(typeof response.data.message === 'string'){
                    this.$notify({
                        type: 'warn',
                        text: response.data.message
                    });
                }
                else{
                    if(response.data.message['file']){
                        let fileList = response.data.message['file'];
                        for(let i=0;i<fileList.length;i++){
                            if(fileList[i].type==2 || fileList[i].type==5){
                                self.error.idFront=fileList[i].message;
                            }
                            else if(fileList[i].type==4 || fileList[i].type==6){
                                self.error.idHold=fileList[i].message;
                            }
                            else if(fileList[i].type==3){
                                self.error.idReverse=fileList[i].message;
                            }
                        }
                    }
                    self.success = false;
                    self.$emit('file-uploaded');
                }
            }      
            else if(response.status == 401 && response.data.name == "Unauthorized"){
                    localStorage.removeItem("token");
                    localStorage.removeItem("member");
                    localStorage.removeItem("isFirstTime");
                    this.$router.push({ 
                        path: '/login', 
                    });
            }
            else{
                if(localStorage.getItem("token")){
                    var msg = (response.data)?response.data.message:err.message;
                    this.$notify({
                        type: 'warn',
                        text: msg
                    })
                }
            }
        }catch(e){
            console.log(err);
        }
    },
    togglePopup(index){
        this['showPopup_'+index]=!this['showPopup_'+index];
    },
    captureFile($event,key) {
        this.params[key]=$event;
        this.error[key]="";
    },
    removeImage($event,key){
        this.error[key]="";
    },
    doEscapeMarkup(markup){
        return markup;
    }
  },
  mounted(){
        let self = this;
        this.$nextTick(() => {
        
            CreateAccount.getProvince({"country":"CHN"}).then(response => {
                const data = response.data.data;
                this.provinceOpt = [];
                data.forEach(item => {
                    this.provinceOpt.push({"id":item.value,"text":item.text,"code":item.id});    
                });
                
                if(this.information){
                    
                    Object.keys(this.params).forEach(function(key) {
                        if(typeof self.file[key]!=="undefined" && self.information[key]){
                            self.file[key]=self.information[key];
                            self.getFile(key,self.information[key]);
                        }
                        else{
                            self.params[key]=self.information[key];
                        }
                    });

                    if(this.params.province){
                        let data_province = this.params.province.split("_");
                        this.getCity(data_province[0]);
                    }
                    
                    if(this.params.city){
                        let data_city = this.params.city.split("_");
                        this.getDistrict(data_city[0]);
                    }
                }

                if(this.user_no){
                    this.userNo = this.user_no;
                    this.accountId = this.account_id;
                }

            }).catch(err => {
                this.checkError(err);
            });
        });
    }
}
</script>

<style>
.form-group{
    margin-bottom: 0 !important;
}
</style>